import React, { useState, useReducer, useEffect } from 'react';
import { Empty, Form, Divider, Radio, Col, Button, Pagination, Checkbox, Space, Modal, Input, Select, InputNumber, DatePicker } from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  CaretUpOutlined,
  CloseOutlined,
  EditOutlined,
  CheckOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

import {
  getEntityColumnInfo,
  getEntityTableInfo,
  getList,
  getById,
  updateById,
  deleteById,
  insert,
} from '../../services/Entity';
import { Page } from '../';

import './style';

export default React.forwardRef((props, ref) => {
  const { reload, entity, relation, addColumns, newForm, editForm, formWidth, isMaximize } = props;
  const [formNew] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [isShowNew, setShowNew] = useState(false);
  const [isShowEdit, setShowEdit] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const onChangePage = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  }

  const initialState = {
    title: undefined,
    columns: [],
    rows: [],
    total_rows: 0,
    pagination: { limit: 10, offset: 0 },
  };

  function reducer(state, action) {
    switch (action.type) {
      case 'title':
        return Object.assign({}, state, { title: action.data });
      case 'columns':
        return Object.assign({}, state, { columns: action.data });
      case 'list':
        return Object.assign({}, state, { rows: action.data, total_rows: action.data.length });
      case 'new':
        return { total: state.total + 1 };
      case 'edit':
        return { total: state.total };
      case 'delete':
        return { total: state.total - 1 };
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const { title, rows, total_rows } = state;
  useEffect(() => {
    getList(entity).then(data => dispatch({ type: 'list', data: data }));
    getEntityTableInfo(entity).then(data => dispatch({ type: 'title', data: data }));
    getEntityColumnInfo(entity).then(data => dispatch({ type: 'columns', data: data }));
  }, []);
  const showDeleteConfirm = (id, name) => {
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{id + ' : ' + name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteById(entity, id).then(() => {
          getList(entity).then(data => dispatch({ type: 'list', data: data }));
          reload && reload(entity.replace('fm_',''));
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const onEdit = (index) => {
    setSelectedIndex(index);
    setShowEdit(true);
  }

  const onEditFinish = async () => {
    const values = await formEdit.validateFields();
    let db_values = '';
    for (let o in values) {
      db_values = db_values.concat(o + "='" + values[o] + "',");
    }
    db_values = db_values.concat("updator ='sysadmin'");
    const body = {
      value: db_values
    }
    updateById(entity, values.id, body).then(() => {
      getList(entity).then(data => dispatch({ type: 'list', data: data }));
      setShowEdit(false);
      reload && reload(entity.replace('fm_',''));
    });

  }
  const onDelete = (index) => {
    setSelectedIndex(index);
    const name = rows[index].name || rows[index].name_cn || rows[index].name_en;
    showDeleteConfirm(rows[index].id, name);
  }
  const onNew = async () => {
    const values = await formNew.validateFields();
    let db_columns = '';
    let db_values = '';
    for (let o in values) {
      db_columns = db_columns.concat(o + ',');
      db_values = db_values.concat("'" + values[o] + "',");
    }
    db_columns = db_columns.concat('creater, updator');
    db_values = db_values.concat("'sysadmin','sysadmin'");
    const body = {
      entity: entity,
      columns: db_columns,
      values: db_values
    }
    insert(entity, body).then(() => {
      getList(entity).then(data => dispatch({ type: 'list', data: data }));
      setShowNew(false);
      formNew.resetFields();
      reload && reload(entity.replace('fm_',''));
    });

  }
  const onClose = () => {
    setShowEdit(false);
    setShowNew(false);
  }

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const { columns } = state;
  const newBody = () => {
    const arr = [];
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].field === 'id') continue;
      if (columns[i].type.startsWith('int')) {
        const rel = (relation || {})[columns[i].field];
        if (rel) {
          arr.push(
            <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入'+columns[i].comment }]}>
              <Select placeholder={`请选择${columns[i].comment}`} >
                {rel.data.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item[rel.field]}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>)
        } else {
          arr.push(<Col span={24}>
            <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入'+columns[i].comment }]}>
              {
                columns[i].type.startsWith('int') && (
                  <InputNumber />
                )
              }
            </Form.Item>
          </Col>);
        }
      } else if (columns[i].type.startsWith('bool')) {
        arr.push(<Col span={24}>
          <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入'+columns[i].comment }]}>
            <Radio.Group>
              <Radio value={true}>是</Radio>
              <Radio value={false}>否</Radio>
            </Radio.Group>
          </Form.Item></Col>
        );
      } else if (columns[i].type.startsWith('text')) {
        arr.push(<Col span={24}>
          <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入' + columns[i].comment }]}>
            <Input autocomplete="off" />
          </Form.Item></Col>);
      }else if (columns[i].type.startsWith('numeric')) {
        arr.push(<Col span={24}>
          <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入' + columns[i].comment }]}>
            <InputNumber autocomplete="off" />
          </Form.Item></Col>);
      }
    }
    return (
      <Form style={{padding:'1rem'}} {...layout} form={formNew} preserve={false} onFinish={onNew} >
        {arr}
        <Divider style={{ margin: '1rem 0' }} />
        <div className="page-footer">
          <div></div>
          <Space size="large">
            {onClose && <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>}
            {
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>
              </div>
            }
          </Space>
        </div>
      </Form>);
  }

  const editBody = () => {
    if (selectedIndex < 0 || selectedIndex > rows.length - 1) return;
    const selectedItem = rows[selectedIndex];
    const defaultValue = [];
    for (let p in selectedItem) {
      defaultValue.push({ name: p, value: selectedItem[p] });
    }
    const arr = [];
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].type.startsWith('int')) {
        const rel = (relation || {})[columns[i].field];
        if (rel) {
          arr.push(
            <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入客户名称!' }]}>
              <Select placeholder={`请选择${columns[i].comment}`} >
                {rel.data.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item[rel.field]}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>)
        } else {
          arr.push(<Col span={24}>
            <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入客户名称!' }]}>
              {
                columns[i].type.startsWith('int') && (
                  <InputNumber disabled={columns[i].field === 'id'} />
                )
              }
            </Form.Item>
          </Col>);
        }
      } else if (columns[i].type.startsWith('bool')) {
        arr.push(<Col span={24}>
          <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入客户名称!' }]}>
            <Radio.Group>
              <Radio value={true}>是</Radio>
              <Radio value={false}>否</Radio>
            </Radio.Group>
          </Form.Item></Col>
        );
      } else if (columns[i].type.startsWith('text')) {
        arr.push(<Col span={24}>
          <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入客户名称!' }]}>
            <Input autocomplete="off" />
          </Form.Item></Col>);
      }else if (columns[i].type.startsWith('numeric')) {
        arr.push(<Col span={24}>
          <Form.Item label={columns[i].comment} name={columns[i].field} rules={[{ required: true, message: '请输入客户名称!' }]}>
            <Input autocomplete="off" />
          </Form.Item></Col>);
      }
    }
    return (
      <Form style={{padding:'1rem'}} {...layout} form={formEdit} preserve={false} onFinish={onEditFinish} fields={defaultValue}>
        {arr}
        <Divider style={{ margin: '1rem 0' }} />
        <div className="page-footer">
          <div></div>
          <Space size="large">
            {onClose && <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>}
            {
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>
              </div>
            }
          </Space>
        </div>
      </Form>);
  }


  const renderRow = (row, index) => {
    const arr = [];
    arr.push(
      <tr style={{ backgroundColor: row.row_bg }}>
        {
          state.columns.map((column, idx) => {
            const find = (addColumns || []).find(x => x.index === idx);
            if (column.type === 'bool') {
              if (find) {
                return ([<td style={{maxWidth:'240px'}} className="td" align="center">
                  <Checkbox checked={row[column.field]} size="small" />
                </td>, <td className="td" >{find.render(row[column.field], row, index)}</td>])
              }
              return <td style={{maxWidth:'240px'}} className="td" align="center">
                <Checkbox checked={row[column.field]} size="small" />
              </td>
            } else {
              const rel = (relation || {})[column.field];
              console.log(JSON.stringify('rel', rel))
              if (rel) {
                if (find) {
                  return ([<td style={{maxWidth:'240px'}} className="td" >{(rel.data.find(x => x.id === row[column.field]) || {})[rel.field]}</td>,
                  <td style={{maxWidth:'240px'}} className="td" >{find.render(row[column.field], row, index)}</td>])
                }
                return <td style={{maxWidth:'240px'}} className="td" >{(rel.data.find(x => x.id === row[column.field]) || {})[rel.field]}</td>
              } else {
                if (find) {
                  return ([<td style={{maxWidth:'240px'}} className="td" align={column.type.startsWith('int') ? 'right' : ''}>{row[column.field]}</td>
                    , <td style={{maxWidth:'240px'}} className="td" >{find.render(row[column.field], row, index)}</td>]);
                }
                return <td style={{maxWidth:'240px'}} className="td" align={column.type.startsWith('int') ? 'right' : ''}>{row[column.field]}</td>
              }
            }
          })
        }

        <td className="td">
          <Space size="small">
            <Button size="small" onClick={() => onEdit(index)} icon={<EditOutlined />} />
            <Button danger size="small" onClick={() => onDelete(index)} icon={<DeleteOutlined />} />
          </Space>
        </td>
      </tr>
    );
    return arr;
  }

  return (
    <div className="entity-container">
      <div className="entity-container-header">
        <div className="header-title">
          {title}
        </div>
        <div style={{ marginLeft: 'auto' }}></div>
        <Space size="large">
          <div>
            <Button onClick={() => setShowNew(true)} className="header-item" type="primary" icon={<PlusOutlined />}>新建项目</Button>
          </div>
        </Space>
      </div>
      <table style={{tableLayout:'auto'}} className="table table-bordered">
        <thead>
          <tr>
            {
              (state.columns || []).map((item, index) => {
                const find = (addColumns || []).find(x => x.index === index);
                if (find) {
                  return ([
                    <th className="th">{item.comment}
                      {item.sortable && <Button size="small" type="text"><CaretUpOutlined /></Button>}
                    </th>,
                    <th style={{maxWidth:'240px'}} className="th">{find.header}
                      {find.sortable && <Button size="small" type="text"><CaretUpOutlined /></Button>}
                    </th>])
                }
                return (<th style={{maxWidth:'240px'}} className="th">{item.comment}
                  {item.sortable && <Button size="small" type="text"><CaretUpOutlined /></Button>}
                </th>)
              })
            }
            <th className="th">操作</th>
          </tr>
        </thead>
        {
          (rows || []).length > 0 && (
            <tbody className="table-hover">
              {
                (rows || []).map((item, index) => {
                  if (index < (page - 1) * pageSize || index > (page * pageSize > total_rows ? total_rows : page * pageSize) - 1) return null;
                  return renderRow(item, index)
                })
              }
            </tbody>
          )
        }
        {
          (rows || []).length > 0 && (
            <tfoot>
              <tr>
                <td colspan="99" className="td">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>显示第<strong> {(page - 1) * pageSize + 1} </strong>到<strong> {page * pageSize > total_rows ? total_rows : page * pageSize} </strong>条记录，总共<strong> {rows.length} </strong>条记录，每页显示<strong>
                      <Select onChange={(value) => setPageSize(value)} defaultValue={10}>
                        <Select.Option value={10}>10</Select.Option>
                        <Select.Option value={20}>20</Select.Option>
                        <Select.Option value={50}>50</Select.Option>
                        <Select.Option value={100}>100</Select.Option>
                      </Select> </strong>条记录</div>
                    <Pagination onChange={onChangePage} style={{ marginLeft: 'auto' }} pageSize={pageSize} current={page} showSizeChanger={false} total={total_rows} />
                  </div>
                </td>
              </tr>
            </tfoot>
          )
        }
        {
          (rows || []).length === 0 && (
            <td colspan={99} style={{ padding: '10rem' }}>
              <Empty />
            </td>
          )
        }
      </table>
      <Page 
        isMaximize={isMaximize}
        body={newForm ? newForm : newBody()}
        onCloseCallback={() => setShowNew(!isShowNew)} 
        visible={isShowNew} title={"新建" + title} 
        />
      <Page 
        isMaximize={isMaximize}
        body={editForm ? editForm : editBody()}
        onCloseCallback={() => setShowEdit(!isShowEdit)} 
        visible={isShowEdit} title={"编辑" + title} />
    </div>
  );
});
